var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgCampaignDialog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 352,
    viewBox: "0 0 236 352",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 236,
    height: 352,
    rx: 4,
    fill: "url(#paint0_linear_22392_119548)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22392_119548",
    x1: 213.078,
    y1: 359.063,
    x2: -45.7924,
    y2: 167.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#144DDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgCampaignDialog);
export default __webpack_public_path__ + "static/media/BG_Campaign_Dialog.cfb893a67362a0b075ba562c073d414a.svg";
export { ForwardRef as ReactComponent };